var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14.5,
  height: 14.5,
  viewBox: "0 0 14.5 14.5"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3710",
  "data-name": "Group 3710",
  transform: "translate(-701.5 -352.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_2461",
  "data-name": "Rectangle 2461",
  transform: "translate(704 355)",
  fill: "none",
  stroke: "#1268fb",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  rx: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 11,
  height: 11,
  rx: 1.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_103",
  "data-name": "Path 103",
  d: "M3544.446-622.231v-10h10",
  transform: "translate(-2842.446 985.231)",
  fill: "none",
  stroke: "#1268fb",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}))));
export default __webpack_public_path__ + "static/media/copy-icon1.1fa0ac6e.svg";
export { SvgComponent as ReactComponent };